import { Card, Text, Title } from '@mantine/core';
import { CodeHighlight } from '@mantine/code-highlight';
import { useLiveStateManager } from '~/hooks/useLiveStateManager';
import { DebugModeToggle } from '~/components/browser/status-panel/panels/admin/DebugToggle';

export function AdminDebug() {
  const { recorderCursor } = useLiveStateManager();

  return (
    <div className="flex h-full flex-col border-t p-4 dark:border-neutral-700">
      <div className="flex flex-1 flex-col gap-4 overflow-y-auto">
        <DebugModeToggle />
        {/* Recorder State */}
        <Card withBorder>
          <Title
            order={5}
            className="mb-2"
          >
            Recorder Cursor
          </Title>
          {recorderCursor ?
            <CodeHighlight
              code={JSON.stringify(recorderCursor, null, 2)}
              language="tsx"
              withCopyButton
              radius="md"
            />
          : <Text c="dimmed">No recorder state available</Text>}
        </Card>
      </div>
    </div>
  );
}
